import {Text} from '@gravity-ui/uikit';
import {
    Dots9,
    Magnifier,
    ListCheck,
    Persons,
    FileText,
    Gear,
    CircleQuestion,
    BookOpen, SquareBracketsLetterA, FileDollar, AntennaSignal
} from '@gravity-ui/icons';
import {NavigateFunction} from 'react-router-dom';

import type {MakeItemParams, MenuItem} from '@gravity-ui/navigation';

export const createSubheaderItems = (
    navigate: NavigateFunction,
    currentItem: string | null,
    setCurrentItem: React.Dispatch<React.SetStateAction<string | null>>
) => [
    {
        id: 'main-item',
        title: <Text variant="body-2">Главная</Text>,
        icon: Dots9,
        iconSize: 18,
        onItemClick: () => {
            setCurrentItem('main-item');
            navigate('/home');
        },
        current: currentItem === 'main-item'
    }
];

export const createMenuItems = (
    navigate: NavigateFunction,
    currentItem: string | null,
    setCurrentItem: React.Dispatch<React.SetStateAction<string | null>>,
):MenuItem[]  => [
        {
            id: 'orders-item',
            title: <Text variant="body-2">Заказы</Text>,
            icon: ListCheck,
            iconSize: 18,
            onItemClick: () => {
                setCurrentItem('orders-item');
                navigate('/orders');
            },
            current: currentItem === 'orders-item'
        },
        {
            id: 'clients-item',
            title: <Text variant="body-2">Клиенты</Text>,
            icon: Persons,
            iconSize: 18,
            onItemClick: () => {
                setCurrentItem('clients-item');
                navigate('/clients');
            },
            current: currentItem === 'clients-item'
        },
        {
            id: 'reports-item',
            title: <Text variant="body-2">Отчеты</Text>,
            icon: FileText,
            iconSize: 18,
            onItemClick: () => {
                setCurrentItem('reports-item');
                navigate('/reports');

            },
            current: currentItem === 'reports-item',
        },
        {
            id: 'crosses-item',
            title: <Text variant="body-2">Кроссы</Text>,
            icon: BookOpen,
            iconSize: 18,
            onItemClick: () => {
                setCurrentItem('crosses-item');
                navigate('/crosses');
            },
            current: currentItem === 'crosses-item'
        },
        {
            id: 'call-ws',
            title: <Text variant="body-2">WS запросы</Text>,
            icon: AntennaSignal,
            iconSize: 18,
            onItemClick: () => {
                setCurrentItem('call-ws');
                navigate('/call-ws');
            },
            current: currentItem === 'call-ws'
        }
    ]

export const createFooterItems = (
    navigate: NavigateFunction,
    currentItem: string | null,
    setCurrentItem: React.Dispatch<React.SetStateAction<string | null>>
) => [
        {
            id: 'suggest-item',
            title: <Text variant="body-1">Отладка</Text>,
            icon: SquareBracketsLetterA,
            iconSize: 18,
            onItemClick: () => {
                setCurrentItem('suggest-item');
                navigate('/suggest');
            },
            current: currentItem === 'suggest-item',
            roles: ['superadmin', 'supervisor']
        },
        {
            id: 'settings-item',
            title: <Text variant="body-1">Настройки</Text>,
            icon: Gear,
            iconSize: 18,
            onItemClick: () => {
                setCurrentItem('settings-item');
                navigate('/settings');
            },
            current: currentItem === 'settings-item',
            roles: ['superadmin', 'supervisor']
        }
    ];